module.exports = __webpack_public_path__ + "static/img/5.fb45fbd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka3/5.jpg
// module id = 8BUW
// module chunks = 16